var cfnList = []
var httpLock = false

export const mxuserInfo = {
  created() {
    if (!window.userInfo) window.userInfo = {}

    /*
	if(process.env.NODE_ENV == 'development'){
		var testData = {"code":200,"message":"\u4fee\u6539\u6210\u529f","data":{"userId":"1", "img_haibao":'', "id":'26',"name":"\u90ed\u7428","mobile":"18735176779","email":"forloop163@163.com","company_name":"\u4e09\u73af\u5317\u6c7d","position":11,"industry":16,"agreement":1,"status":2,"smkid":"165aefe7c3735a151dabe795a0d34699","openid":"oe9x8t96sjFCiZvT032nSSH7b4bQ","qrcode":"F3N78u79Q8i6","markcode":"2d3u1kun2r","qcid":"usr-v3flcLy1","channel":"1f2130ee-c930-11eb-9f90-acde48001122","from_smkid":null,"created_at":"2021-06-12 23:40:34","updated_at":"2021-06-12 23:40:36","deleted_at":null,"subscribe":[1,2,3,4,5,6,10,11,12,13,4,6,17],"jifen":0}};


		//console.log(testData.data.id);

		setTimeout(() => {
			window.userInfo = testData.data;

			for(var i in window.userInfo){
				if(i == 'openid'){
					this['bindWx'] =  window.userInfo[i]||'';
				}else{
					this[i] =  window.userInfo[i];
				}
			}
		},1000)

	}
	 */

    //console.log(window.userInfo['data'])
    if (window.userInfo['data']) return

    this.getUserInfo()
  },
  methods: {
    _getUserInfo(cfn) {
      cfnList.push(cfn)

      if (httpLock === true) return
      httpLock = true

      this.$http({
        //url: 'http://cic.qingcloud.com/user/api/info',
        url: '/user/api/v2_info',
        method: 'get',
        formData: false,
        data: {}
      })
        .then((res) => {
          cfnList.forEach((itemFn) => {
            itemFn(res)
          })
          //console.log(cfnList.length)
          cfnList = []
          httpLock = false
        })
        .catch(() => {
          cfnList = []
          httpLock = false
        })
    },
    getUserInfo() {
      return
      this._getUserInfo((res) => {
        //console.log('/user/api/info');

        var data = res.data.data
        window.userInfo = data

        for (var i in window.userInfo) {
          if (i == 'openid') {
            this['bindWx'] = window.userInfo[i] || ''
          } else {
            this[i] = window.userInfo[i]
          }
        }

        console.log(this)
      })
    }
  }
}
